import React from 'react';

const AllianceAttack = () => {
  return <h1>AllianceAttack Page</h1>;
};

export default AllianceAttack;
